export default __webpack_public_path__ + "static/media/mr-management-selected-icon.f2edcc10.svg";